import React from 'react';
import { Book, CheckCircle2, Gift } from 'lucide-react';
export function TomosGrid() {
  const tomos = [{
    id: 1,
    level: 'Nivel Inicial',
    weeks: 'Semanas 1 a 10',
    desc: 'La base de todo. Patrones de movimiento, técnica fundamental y adaptación anatómica. El primer contacto del alumno con el funcional real.'
  }, {
    id: 2,
    level: 'Nivel Inicial',
    weeks: 'Semanas 11 a 20',
    desc: 'Consolidación técnica. Correcciones verbales, progresión de carga y confianza en el movimiento.'
  }, {
    id: 3,
    level: 'Nivel Inicial',
    weeks: 'Semanas 21 a 30',
    desc: 'Core funcional y fuerza de base. Kettlebell, peso corporal y primeras progresiones de intensidad.'
  }, {
    id: 4,
    level: 'Nivel Inicial',
    weeks: 'Semanas 31 a 40',
    desc: 'Cierre del nivel inicial. Benchmark de salida y preparación para el salto al nivel intermedio.'
  }, {
    id: 5,
    level: 'Nivel Intermedio',
    weeks: 'Semanas 41 a 50',
    desc: 'Sobrecarga real. RPE, zonas de intensidad y potencia avanzada. Fuerza orientada con Kettlebell.'
  }, {
    id: 6,
    level: 'Nivel Intermedio',
    weeks: 'Semanas 51 a 60',
    desc: 'Fuerza máxima del nivel. Periodización ondulada diaria (DUP) y trabajo metabólico avanzado.'
  }, {
    id: 7,
    level: 'Nivel Intermedio',
    weeks: 'Semanas 61 a 70',
    desc: 'Resistencia de fuerza y circuitos de alta densidad. El punto de inflexión del alumno intermedio.'
  }, {
    id: 8,
    level: 'Nivel Intermedio',
    weeks: 'Semanas 71 a 80',
    desc: 'Benchmark intermedio avanzado. Cierre del nivel y preparación para el salto al avanzado.'
  }, {
    id: 9,
    level: 'Nivel Avanzado',
    weeks: 'Semanas 81 a 90',
    desc: 'Gestos olímpicos y movimientos de alta complejidad técnica. Potencia máxima del sistema.'
  }, {
    id: 10,
    level: 'Nivel Avanzado',
    weeks: 'Semanas 91 a 100',
    desc: 'Fuerza máxima y potencia explosiva. Protocolos de alta intensidad para el atleta avanzado.'
  }, {
    id: 11,
    level: 'Nivel Avanzado',
    weeks: 'Semanas 101 a 110',
    desc: 'Competición y rendimiento. Clases diseñadas para atletas que buscan el límite real.'
  }, {
    id: 12,
    level: 'Nivel Avanzado',
    weeks: 'Semanas 111 a 120',
    desc: 'Cierre del sistema. Benchmark final, evaluación de 120 semanas y protocolo de mantenimiento.'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-205" data-mp="1z0u6l3ujols3">
      <div className="text-center mb-16" data-id="element-206" data-mp="23z47lv2yaglm">
        <h2 className="text-4xl font-extrabold text-stone-900 mb-4" data-id="element-207" data-mp="23xavw1dhd66r">
          Los 12 Tomos Completos
        </h2>
        <p className="text-xl text-stone-600" data-id="element-208" data-mp="28rx6w3fngwqb">
          Clases graficadas · Por nivel y objetivo · Listo para usar mañana
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-209" data-mp="1g8rpxshwl5hu">
        {tomos.map(tomo => <div key={tomo.id} className="bg-white rounded-2xl p-6 border border-stone-200 shadow-sm hover:border-coral-300 hover:shadow-md transition-all" data-id="element-210" data-mp="18ps6xnyctfz0">
            <div className="flex items-center justify-between mb-4" data-id="element-211" data-mp="yqt4wo83gikz">
              <span className="text-coral-500 font-black text-xl" data-id="element-212" data-mp="ttjbyylhxose">
                TOMO {tomo.id}
              </span>
              <Book className="text-stone-300 w-6 h-6" data-id="element-213" data-mp="pshgmsup9wvp" />
            </div>
            <h3 className="text-stone-900 font-bold text-lg mb-1" data-id="element-214" data-mp="l068x3tpx6sl">
              {tomo.level}
            </h3>
            <p className="text-coral-600 text-sm font-medium mb-4" data-id="element-215" data-mp="g0to0omeq9sn">
              — {tomo.weeks}
            </p>
            <p className="text-stone-600 text-sm leading-relaxed" data-id="element-216" data-mp="b3l5gmxck3qv">
              {tomo.desc}
            </p>
          </div>)}
      </div>

      <div className="flex flex-wrap justify-center gap-6 text-sm md:text-base font-medium text-stone-700 bg-white py-6 rounded-2xl border border-stone-200 shadow-sm" data-id="element-217" data-mp="659rc000r72u">
        <span className="flex items-center" data-id="element-218" data-mp="qt19c9e6mvwu">
          <span className="mr-2" data-id="element-219" data-mp="vrb78rrakam5">✏️</span> Ejercicios graficados en cada tomo
        </span>
        <span className="flex items-center" data-id="element-220" data-mp="i060l5piai2b">
          <span className="mr-2" data-id="element-221" data-mp="hzegos59u8rv">⚡</span> Sistema "Abre y Dicta"
        </span>
        <span className="flex items-center" data-id="element-222" data-mp="m0zq23ilk4xb">
          <span className="mr-2" data-id="element-223" data-mp="lzyapmujsw9s">📋</span> Fichas listas para imprimir
        </span>
      </div>
    </section>;
}
export function BonusesGrid() {
  const bonuses = [{
    id: 1,
    icon: '🛡️',
    title: 'Protocolo Pre-Hab: Cero Lesiones',
    desc: 'Rutinas de movilidad y activación para prevenir lesiones de hombro, rodilla y columna en tus alumnos. El protocolo que te protege a ti y a tu clase.',
    bg: 'bg-sky-700',
    spine: 'bg-sky-900'
  }, {
    id: 2,
    icon: '🍗',
    title: 'Nutrición de Campo: El Profe a Fuego',
    desc: 'Guía práctica para asesorar a tus alumnos sobre nutrición sin ser nutricionista. Lo que funciona de verdad en el campo.',
    bg: 'bg-coral-500',
    spine: 'bg-coral-700'
  }, {
    id: 3,
    icon: '💊',
    title: 'Guía de Suplementación Inteligente',
    desc: 'Qué recomendar, qué evitar y cómo responder las preguntas de tus alumnos con fundamento real.',
    bg: 'bg-violet-700',
    spine: 'bg-violet-900'
  }, {
    id: 4,
    icon: '⚡',
    title: 'El WOD del Profe: Entrenar en 30 Minutos',
    desc: 'Sesiones de alta intensidad diseñadas para el profesor que no tiene tiempo. Porque si tú no entrenas, tu autoridad se va al piso.',
    bg: 'bg-amber-600',
    spine: 'bg-amber-800'
  }, {
    id: 5,
    icon: '🧠',
    title: 'Mentalidad de Coach-Atleta',
    desc: 'Herramientas de liderazgo, manejo de grupos difíciles y cómo construir una comunidad que no se va a otro gimnasio.',
    bg: 'bg-slate-800',
    spine: 'bg-slate-950'
  }, {
    id: 6,
    icon: '👁️',
    title: 'Anatomía Visual: El Ojo Clínico del Profe',
    desc: 'Guía visual para detectar errores técnicos en 3 segundos. Los 6 movimientos base del funcional con sus errores más comunes y cómo corregirlos al instante.',
    bg: 'bg-emerald-700',
    spine: 'bg-emerald-900'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-stone-50 border-y border-stone-200" data-id="element-224" data-mp="t7oj8ivcykow">
      <div className="max-w-7xl mx-auto" data-id="element-225" data-mp="y6jb0abazjl5">
        <div className="text-center mb-12" data-id="element-226" data-mp="y5gjq1a2jf4p">
          <h2 className="text-4xl md:text-5xl font-extrabold text-stone-900 mb-4" data-id="element-227" data-mp="135cq2768ninf">
            + 6 Regalos Estratégicos
          </h2>
          <p className="text-lg md:text-xl text-stone-600 mb-8" data-id="element-228" data-mp="17x481tbbwg1y">
            Incluidos sin costo extra · Valor real del pack
          </p>
          <div className="inline-flex items-center justify-center bg-coral-500 text-white font-bold text-base md:text-lg px-8 py-4 rounded-full shadow-lg shadow-coral-500/20" data-id="element-229" data-mp="1cx8qhovsrkut">
            <Gift className="w-5 h-5 mr-2" data-id="element-230" data-mp="1lwlyse86q3dy" />
            🎁 GRATIS POR EL DÍA DE HOY
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-231" data-mp="36f6bg4dxoiq3">
          {bonuses.map(bonus => <div key={bonus.id} className="bg-white rounded-3xl p-6 md:p-8 border border-stone-200 shadow-sm hover:shadow-md transition-shadow flex flex-col items-center text-center" data-id="element-232" data-mp="2xd6t98r6n8lk">
              {/* Book cover mockup */}
              <div className="relative mb-6 mt-2 transform hover:scale-105 transition-transform duration-300" data-id="element-233" data-mp="3p3uq48ltprtf">
                <div className={`relative ${bonus.bg} rounded-xl w-44 h-60 shadow-xl overflow-hidden flex flex-col justify-between p-5`} data-id="element-234" data-mp="3l4vs77yievbh">
                  {/* Book spine effect */}
                  <div className={`absolute left-0 top-0 bottom-0 w-3 ${bonus.spine}`} data-id="element-235" data-mp="cmzare1hm6ax" />
                  <div className="absolute left-3 top-0 bottom-0 w-px bg-white/20" data-id="element-236" data-mp="7vpq6ruspt5w" />

                  {/* Icon at top */}
                  <div className="text-4xl ml-2" data-id="element-237" data-mp="3cdaekh679rra">{bonus.icon}</div>

                  {/* Bonus N */}
                  <div className="ml-2" data-id="element-238" data-mp="3h5kbih5qfs32">
                    <p className="text-white font-extrabold text-2xl leading-tight" data-id="element-239" data-mp="3h6lleib0i8j7">
                      Bonus {bonus.id}
                    </p>
                  </div>

                  {/* Separator + brand */}
                  <div className="ml-2" data-id="element-240" data-mp="3v4ticq81t9ud">
                    <div className="h-px bg-white/30 mb-3" data-id="element-241" data-mp="3v5v0tfre8ym4" />
                    <p className="text-white/80 font-bold text-[10px] tracking-widest uppercase" data-id="element-242" data-mp="3yscqx6ur8g4">
                      Funcional 360™
                    </p>
                  </div>
                </div>
              </div>

              {/* GRATIS pill */}
              <div className="inline-flex items-center bg-emerald-50 text-emerald-700 font-bold text-xs px-4 py-1.5 rounded-full mb-4 border border-emerald-100" data-id="element-243" data-mp="3q3np8rah7kkb">
                GRATIS
              </div>

              {/* Title */}
              <h3 className="text-lg md:text-xl font-extrabold text-stone-900 mb-3 leading-snug" data-id="element-244" data-mp="276iyrjri931e">
                <span className="mr-1" data-id="element-245" data-mp="227y6q7meppo1">{bonus.icon}</span>
                Bonus {bonus.id} — {titleWithoutPrefix(bonus.title)}
              </h3>

              {/* Description */}
              <p className="text-stone-600 text-sm md:text-base leading-relaxed" data-id="element-246" data-mp="2h2m93cwig7zf">
                {bonus.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}
function titleWithoutPrefix(title: string) {
  return title.split('—')[1]?.trim() || title;
}